// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ele-form-bmap{width:100%;margin-top:20px;border-radius:5px;overflow:hidden}.ele-form-search-keywords{max-width:80%;text-overflow:ellipsis;overflow:hidden}.ele-form-search-location{font-size:12px;color:#b4b4b4}.highlighted .ele-form-search-location{color:#ddd}", ""]);
// Exports
module.exports = exports;
